import React from 'react'

interface PreviewIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const PreviewIcon: React.FC<PreviewIconProps> = ({
  color = '#888',
  gradient,
  width = 24,
  height = 24,
  alt = 'Preview icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M2.42 11.766C3.93 8.021 7.651 5.375 12 5.375s8.07 2.646 9.58 6.391l.094.234-.094.234c-1.51 3.745-5.231 6.391-9.58 6.391s-8.07-2.646-9.58-6.391L2.326 12l.094-.234zM3.678 12c1.38 3.155 4.58 5.375 8.322 5.375 3.741 0 6.942-2.22 8.322-5.375-1.38-3.155-4.58-5.375-8.322-5.375-3.741 0-6.942 2.22-8.322 5.375z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M8.375 12A3.621 3.621 0 0112 8.375 3.621 3.621 0 0115.625 12 3.621 3.621 0 0112 15.625 3.621 3.621 0 018.375 12zM12 9.625A2.371 2.371 0 009.625 12 2.371 2.371 0 0012 14.375 2.371 2.371 0 0014.375 12 2.371 2.371 0 0012 9.625zM0 0h5.5a.5.5 0 010 1H1v4.5a.5.5 0 01-1 0V0zM24 0v5.5a.5.5 0 01-1 0V1h-4.5a.5.5 0 010-1H24zM24 24h-5.5a.5.5 0 010-1H23v-4.5a.5.5 0 011 0V24zM0 24v-5.5a.5.5 0 011 0V23h4.5a.5.5 0 010 1H0z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default PreviewIcon
